/**
 * Rotating brand-panel sentences for the WiFiBot login shell.
 * Index 0 is the anchor line shown when motion is reduced or the viewport is
 * narrow. Edit copy here only. Keep every sentence ≤ 64 characters (enforced
 * by proofs.test.ts). Source: wifibot.ai.
 */
export const WIFIBOT_PROOFS: readonly string[] = [
  "Your whole network, under control.",
  "Built for the people who keep networks alive.",
  "Signal, not noise.",
  "An inventory that builds itself.",
  "Every device, one pipeline.",
  "Resolution without the wait.",
  "Proof, not promises.",
  "From the NOC to your pocket.",
  "The network is just the beginning.",
  "WiFiSOC — the security layer.",
];
